/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SessionIntent } from './SessionIntent';
import {
    SessionIntentFromJSON,
    SessionIntentFromJSONTyped,
    SessionIntentToJSON,
    SessionIntentToJSONTyped,
} from './SessionIntent';

/**
 * 
 * @export
 * @interface SetRunIntentResponse
 */
export interface SetRunIntentResponse {
    /**
     * 
     */
    runId: string;
    /**
     * 
     */
    sessionIntent: SessionIntent;
    /**
     * 
     */
    intentOverride: SessionIntent | null;
    /**
     * 
     */
    notifiedCaptureIds: Array<string>;
}



/**
 * Check if a given object implements the SetRunIntentResponse interface.
 */
export function instanceOfSetRunIntentResponse(value: object): value is SetRunIntentResponse {
    if ((!('runId' in (value as Record<string, any>)) && !('run_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['runId'] === undefined && (value as Record<string, any>)['run_id'] === undefined)) return false;
    if ((!('sessionIntent' in (value as Record<string, any>)) && !('session_intent' in (value as Record<string, any>))) || ((value as Record<string, any>)['sessionIntent'] === undefined && (value as Record<string, any>)['session_intent'] === undefined)) return false;
    if ((!('intentOverride' in (value as Record<string, any>)) && !('intent_override' in (value as Record<string, any>))) || ((value as Record<string, any>)['intentOverride'] === undefined && (value as Record<string, any>)['intent_override'] === undefined)) return false;
    if ((!('notifiedCaptureIds' in (value as Record<string, any>)) && !('notified_capture_ids' in (value as Record<string, any>))) || ((value as Record<string, any>)['notifiedCaptureIds'] === undefined && (value as Record<string, any>)['notified_capture_ids'] === undefined)) return false;
    return true;
}

export function SetRunIntentResponseFromJSON(json: any): SetRunIntentResponse {
    return SetRunIntentResponseFromJSONTyped(json, false);
}

export function SetRunIntentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetRunIntentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'runId': json['run_id'],
        'sessionIntent': SessionIntentFromJSON(json['session_intent']),
        'intentOverride': SessionIntentFromJSON(json['intent_override']),
        'notifiedCaptureIds': json['notified_capture_ids'],
    };
}

export function SetRunIntentResponseToJSON(json: any): SetRunIntentResponse {
    return SetRunIntentResponseToJSONTyped(json, false);
}

export function SetRunIntentResponseToJSONTyped(value?: SetRunIntentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'run_id': value['runId'],
        'session_intent': SessionIntentToJSON(value['sessionIntent']),
        'intent_override': SessionIntentToJSON(value['intentOverride']),
        'notified_capture_ids': value['notifiedCaptureIds'],
    };
}

